import { ApiParameter, get, HasPagingParameters, post } from "@insite/client-framework/Services/ApiService";
import { ProductCollectionModel } from "@insite/client-framework/Types/ApiModels";
import { CrossReferenceLookupModel } from "@tIntermatic/Types/CrossReferenceLookupModel";

const matchingIntProductUrl = "/api/v1/matchingintermaticproduct";
const lookUpmatchingIntProductUrl = "/api/v1/crossreferencelookup";

export interface GetMatchingProductCollectionApiV1Parameter extends ApiParameter, HasPagingParameters {
    Search?: string;
}

export function getMatchingProductCollectionV1(parameter: GetMatchingProductCollectionApiV1Parameter) {
    return get<ProductCollectionModel>(matchingIntProductUrl, parameter);
}

export interface GetCrossReferenceLookupParameter extends ApiParameter {
    search?: string;
}

export function getCrossReferenceLookupCollection(parameter: GetCrossReferenceLookupParameter) {
    return get<CrossReferenceLookupModel>(lookUpmatchingIntProductUrl, parameter);
}
